import React from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import DevelopmentBanner from './components/DevelopmentBanner'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import HowItWorks from './components/HowItWorks'
import AppScreenshots from './components/AppScreenshots'
import Rewards from './components/Rewards'
import FAQ from './components/FAQ'
import CTA from './components/CTA'
import Footer from './components/Footer'
import PrivacyPolicy from './components/Datenschutz'
import MerchantCenter from './components/MerchantCenter'
import ScrollToTop from './components/ScrollToTop'
import './App.css'

function Home() {
  return (
    <>
      <DevelopmentBanner />
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <AppScreenshots />
      <Rewards />
      <MerchantCard />
      <FAQ />
      <CTA />
      <Footer />
    </>
  )
}

function MerchantCenterPage() {
  return (
    <>
      <DevelopmentBanner />
      <Header />
      <MerchantCenter />
      <Footer />
    </>
  )
}

function MerchantCard() {
  return (
    <section className="merchant-card-section section">
      <div className="container">
        <div className="merchant-card">
          <div className="merchant-card-content">
            <h2 className="merchant-card-title">Merchant werden?</h2>
            <p className="merchant-card-text">
              Erfahren Sie, wie Sie Ihre Kampagnen-Videos erstellen und hochladen können. 
              Sehen Sie Beispiele und Richtlinien für erlaubte Formate.
            </p>
            <Link to="/merchant-center" className="btn btn-primary btn-large">
              Zum Merchant Center
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/datenschutz" element={<PrivacyPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/merchant-center" element={<MerchantCenterPage />} />
      </Routes>
    </>
  )
}

export default App
